import React from "react";

export default function DataWipedView({ onBackToLogin }) {
  return (
    <div style={{ backgroundColor: "#000", color: "#fff", height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#000",
          borderBottom: "1px solid #222",
          padding: "1rem",
        }}
      >
        <h2 style={{ margin: 0 }}>Unlink</h2>
      </div>

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        {/* Bomb Icon */}
        <img
          src="/images/atomic-bomb-icon.png"
          alt="Wipe Icon"
          style={{ width: "250px", height: "250px", marginBottom: "1.5rem", opacity: 0.85 }}
        />

        <h3 style={{ color: "#f66", marginBottom: "0.5rem" }}>Your data has been wiped</h3>

        <p style={{ color: "#ccc", fontSize: "0.95rem", maxWidth: "320px", lineHeight: "1.4", marginBottom: "1.5rem" }}>
          You entered your wipe password. All Unlink data stored on this device has been permanently erased.
        </p>

        <p style={{ color: "#888", fontSize: "0.85rem", maxWidth: "320px", lineHeight: "1.4", marginBottom: "2rem" }}>
          To fully finish:
          <br />• Close all tabs from Unlink<br />• Quit your browser completely
        </p>

        <button
          onClick={onBackToLogin}
          style={{
            backgroundColor: "#4e8cff",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "0.75rem 1.25rem",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}